var _desc, _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUserOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip139_573"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "user/outline",
    width: 28,
    height: 28,
    fill: "white",
    fillOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "user/outline",
    width: 28,
    height: 28,
    fill: "#FFFFFF",
    fillOpacity: 0
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip139_573)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 12",
    cx: 14,
    cy: 14,
    r: 13.5,
    stroke: "#2F2F2F",
    strokeOpacity: 1,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.4752 10.7947C15.8187 11.4679 14.9283 11.8461 14 11.8461C13.0717 11.8461 12.1813 11.4679 11.5248 10.7947C10.8683 10.1215 10.4995 9.20847 10.4995 8.25641C10.4995 7.30435 10.8683 6.39127 11.5248 5.71808C12.1813 5.04486 13.0717 4.66666 14 4.66666C14.9283 4.66666 15.8187 5.04486 16.4752 5.71808C17.1317 6.39127 17.5005 7.30435 17.5005 8.25641C17.5005 9.20847 17.1317 10.1215 16.4752 10.7947ZM9.09021 16.7704C10.3997 15.4492 12.1631 14.7088 14 14.7088C15.8369 14.7088 17.6003 15.4492 18.9098 16.7704C20.2194 18.0915 20.97 19.8875 21 21.7711C18.804 22.8037 16.4159 23.3367 14 23.3333C11.5021 23.3333 9.1311 22.7743 7 21.7711C7.03003 19.8875 7.78064 18.0915 9.09021 16.7704Z",
    stroke: "#2F2F2F",
    strokeOpacity: 1,
    strokeWidth: 1,
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserOutline);
export default __webpack_public_path__ + "static/media/user_outline.a78fadedc3890357e77d7f64fcbb1c81.svg";
export { ForwardRef as ReactComponent };